import { Select } from 'components/v2/Select'
import { ReactElement } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { EPassengerProperty, IPassengerPropertyOptions, ISelectPassengerPropertyProps } from './types'

const messages = defineMessages({
  selectPassengerProperty: {
    id: 'passengerProperty.new.form.selectPassengerProperty',
    defaultMessage: 'Choose passenger property'
  }
})

export const PASSENGER_PROPERTY_OPTIONS: IPassengerPropertyOptions = {
  MX: [
    EPassengerProperty.MILITARY,
    EPassengerProperty.STUDENT,
    EPassengerProperty.TEACHER,
    EPassengerProperty.WHEELCHAIR,
    EPassengerProperty.DISABILITY
  ],
  US: [EPassengerProperty.VETERAN, EPassengerProperty.WHEELCHAIR]
}

export const SelectPassengerProperty = ({
  value,
  onBlur,
  touched,
  errors,
  disabled,
  onChange,
  countryCode
}: ISelectPassengerPropertyProps): ReactElement => {
  const intl = useIntl()
  const options = PASSENGER_PROPERTY_OPTIONS[countryCode] ?? []
  return (
    <Select
      id="selectPassengerProperty"
      value={value}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
        onChange(e.target.value)
      }}
      onBlur={onBlur}
      touched={touched}
      errors={errors}
      label={<FormattedMessage id="dictionary.passengerProperty" defaultMessage="Passenger Property" />}
      disabled={disabled}
    >
      <option value="">{intl.formatMessage(messages.selectPassengerProperty)}</option>

      {options.map((option) => {
        return (
          <option key={option} value={option}>
            {option}
          </option>
        )
      })}
    </Select>
  )
}
